/* -------------------------------------------------------------------------- */
/*                                   TITLES                                   */

const create = {
	complete: {
		overview: {
			account_row_title: "daDup Storage-Konto",
			desc: "Überprüfen Sie die Zusammenfassung des daDup Storage-Kontos, das Sie bestellen möchten.",
			description: "Beschreibung",
			relation: "Beziehung",
			title: "Konfigurationsübersicht",
		},
		page_title: "Bestellübersicht daDup-Konto",
		product_details_desc: "Passen Sie hier die Daten Ihres daDup Storage-Kontos an.",
		product_details_title: "Details zum daDup Storage-Konto",
		product_header_title: "Produktübersicht",
		product_title: "S3 Storage",
		submit_button: "Erstellen",
		success_toast: "daDup erfolgreich erstellt!",
	},
	config: {
		description: "Wählen Sie einen Namen für Ihr daDup-Konto.",
		placeholder_description: "Optionale Beschreibung",
		placeholder_description_helper: "Geben Sie eine Beschreibung für Ihr daDup-Konto ein.",
		section_label: "daDup-Kontoinformationen.",
		title: "daDup-Kontokonfiguration",
	},
	header: "daDup-Konto erstellen",
	kind: {
		description: "Wählen Sie den daDup-Kontotyp.",
		options: {
			default: "Neues daDup-Konto",
			disabled_text: "Dies ist nicht verfügbar",
		},
		title: "daDup-Kontotyp",
	},
	other_info: {
		description:
			"Wählen Sie optional eine Relation, mit der dieses Konto verknüpft werden soll. Das Verknüpfen einer Relation beeinflusst die Funktionalität nicht. Sie können auch andere Produkte mit einer Relation verknüpfen und so sehen, was eine Relation insgesamt nutzt.",
		options: {
			enabled: "Mit Relation verknüpfen",
		},
		section_label: "Mit Relation verknüpfen",
		title: "Weitere Informationen",
	},
};

export default create;
